<div id="control-pad">
    <button id="control-left" class="button"></button>
    <button id="control-right" class="button"></button>
    <button id="control-up" class="button"></button>
    <button id="control-down" class="button"></button>
    <button id="control-black" class="button checkbox"></button> 
    <button id="control-white" class="button checkbox"></button>
    <button id="control-erase" class="button"></button>
    <button id="control-undo" class="button"></button>
    <button id="control-redo" class="button"></button>
</div>